import {Component, Inject} from '@angular/core';
import {MD_DIALOG_DATA, MdDialogRef} from '@angular/material';

@Component({
  selector: 'app-error-dialog',
  template: `
    <md-dialog-content>ERROR: {{data.message}}</md-dialog-content>
    <div md-dialog-actions>
      <button md-button md-dialog-close="ok">OK</button>
    </div>
  `,
  styles: [`
    .mat-dialog-actions {
      justify-content: flex-end;
    }
  `]
})
export class ErrorDialogComponent {
  constructor(public dialogRef: MdDialogRef<ErrorDialogComponent>,
              @Inject(MD_DIALOG_DATA) public data) { }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/components/error-dialog/error-dialog.component.ts